import React, { useState } from "react";
import SEO from "@/components/SEO";
import ContactForm from "@/components/ContactForm";
import BreadcrumbNav from "@/components/BreadcrumbNav";
import { SITE } from "@/lib/site";
import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const BREADCRUMBS = [{ label: "Home", to: "/" }, { label: "Contact" }];

export default function Contact() {
  const [interestMaintenance, setInterestMaintenance] = useState(false);
  const [interestRoofing, setInterestRoofing] = useState(false);
  return (
    <>
      <SEO title="Contact Black Ridge Construction | Austin TX" description="Contact Black Ridge Construction for residential construction, roofing, remodeling, repairs, and maintenance plans in Austin and Central Texas." />

      <section className="bg-br-black text-white">
        <div className="container-br py-12 lg:py-16">
          <BreadcrumbNav dark items={BREADCRUMBS} />
          <div className="max-w-3xl mt-5">
            <div className="br-eyebrow text-br-bronze-2">Get In Touch</div>
            <h1 className="br-headline text-4xl sm:text-5xl mt-3">Talk to a Real General Contractor</h1>
            <p className="mt-4 text-gray-300">Submit the form, call, or email. We respond promptly and walk you through next steps without pressure.</p>
          </div>
        </div>
      </section>

      <section className="section-pad bg-br-paper">
        <div className="container-br grid lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 bg-white rounded p-6 lg:p-8 border border-gray-200">
            <ContactForm endpoint="/leads/contact" title="Send Us a Message" source_page="contact" />
            <div className="mt-6 grid sm:grid-cols-2 gap-3 text-sm">
              <label className="flex items-start gap-2 text-gray-700">
                <input type="checkbox" checked={interestMaintenance} onChange={(e) => setInterestMaintenance(e.target.checked)} />
                <span>I'm interested in a <Link className="text-br-bronze underline" to="/maintenance-plans">maintenance plan</Link>.</span>
              </label>
              <label className="flex items-start gap-2 text-gray-700">
                <input type="checkbox" checked={interestRoofing} onChange={(e) => setInterestRoofing(e.target.checked)} />
                <span>I'd like a <Link className="text-br-bronze underline" to="/roofing">roof inspection</Link>.</span>
              </label>
            </div>
          </div>
          <div className="space-y-4">
            <div className="p-5 bg-br-black text-white rounded">
              <div className="br-eyebrow text-br-bronze-2">Phone</div>
              <a href={`tel:${SITE.phoneE164}`} className="font-display text-2xl tracking-widest mt-1 block hover:text-br-bronze-2"><Phone size={16} className="inline mr-2"/>{SITE.phone}</a>
              <p className="text-xs text-gray-400 mt-1">Click to call. Standard hours preferred for non-urgent calls.</p>
            </div>
            <div className="p-5 bg-white border border-gray-200 rounded">
              <div className="br-eyebrow">Email</div>
              <a href={`mailto:${SITE.email}`} className="text-lg break-all mt-1 inline-block hover:text-br-bronze"><Mail size={14} className="inline mr-1"/>{SITE.email}</a>
            </div>
            <div className="p-5 bg-white border border-gray-200 rounded">
              <div className="br-eyebrow">Service Area</div>
              <div className="mt-1 text-sm text-gray-700"><MapPin size={14} className="inline mr-1 text-br-bronze"/>{SITE.serviceArea}</div>
              <div className="mt-2 text-xs text-gray-500 leading-relaxed">Austin, Round Rock, Cedar Park, Georgetown, Leander, Pflugerville, Kyle, Buda, San Marcos, Dripping Springs, Lakeway, Bee Cave, Bastrop, and surrounding communities.</div>
              <Link to="/service-areas" className="mt-3 inline-block text-xs uppercase font-bold tracking-widest text-br-bronze hover:underline">View All Service Areas →</Link>
            </div>
            <div className="p-5 bg-br-paper-2 border border-gray-200 rounded">
              <div className="br-eyebrow">Subcontractor?</div>
              <p className="text-sm text-gray-700 mt-1">Apply to our trade partner network.</p>
              <Link to="/subcontractor-partnerships" className="mt-3 inline-block text-xs uppercase font-bold tracking-widest text-br-bronze hover:underline">Subcontractor Application →</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
